import { render, staticRenderFns } from "./GoalDetailChart.vue?vue&type=template&id=d70be224&scoped=true&"
import script from "./GoalDetailChart.vue?vue&type=script&lang=js&"
export * from "./GoalDetailChart.vue?vue&type=script&lang=js&"
import style0 from "./GoalDetailChart.vue?vue&type=style&index=0&id=d70be224&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d70be224",
  null
  
)

/* custom blocks */
import block0 from "./GoalDetailChart.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d70be224')) {
      api.createRecord('d70be224', component.options)
    } else {
      api.reload('d70be224', component.options)
    }
    module.hot.accept("./GoalDetailChart.vue?vue&type=template&id=d70be224&scoped=true&", function () {
      api.rerender('d70be224', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/goal/GoalDetailChart.vue"
export default component.exports